var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AgencyInfoService } from 'app/services/agency-info.service';
import { UserService } from 'app/services/user.service';
var AddSubAgencyModalComponent = /** @class */ (function () {
    function AddSubAgencyModalComponent(dialogRef, 
    // private attrIndexService: AttrIndexService,
    // private domainService: DomainService,
    // private nagService: NagService,
    agencyInfoService, userService) {
        this.dialogRef = dialogRef;
        this.agencyInfoService = agencyInfoService;
        this.userService = userService;
        this.givInfo = {
            nguidPattern: {
                layerType: false
            },
        };
        this.givBdryCateList = [];
        this.countyList = [];
    }
    AddSubAgencyModalComponent.prototype.create = function () {
        if (this.shortName && this.adminEmail && this.password && this.confirmPassword && this.password === this.confirmPassword) {
            var data = {
                name: this.shortName,
                desc: this.longName,
                pw: this.password,
                adminEmail: this.adminEmail,
                cusProps: {
                    discripAgId: this.givInfo.discrepancyAgencyId,
                    givBoundaryName: this.givInfo.bdryName,
                    givBoundaryCat: this.givInfo.bdryCate,
                    customerCounties: [this.givInfo.county.name],
                    customerCentroid: this.givInfo.county.centroidStr,
                    customerState: this.userService.customerInfo.givState,
                    customerNguidPattern: this.givInfo.nguidPattern.layerType ? 2 : 1
                }
            };
            this.dialogRef.close(data);
        }
    };
    AddSubAgencyModalComponent.prototype.onSelectCounty = function () {
        var _this = this;
        if (this.givInfo.county) {
            this.givInfo.bdryName = this.givInfo.county.name;
            var county = this.countyList.find(function (c) { return c.name === _this.givInfo.county.name; });
            // if (!county.isNeighbor) {
            // 	county.isNeighbor = true;
            // }
            // this.givInfo.centroidLatlong = this.givInfo.county.centroidStr;
        }
        else {
            this.givInfo.bdryName = '';
            // this.givInfo.centroidLatlong = null;
        }
    };
    AddSubAgencyModalComponent.prototype.onPatternChange = function (e) {
        this.givInfo.nguidPattern = e;
    };
    AddSubAgencyModalComponent.prototype.initGivBdryTypes = function () {
        // TODO!!!!!!!!
        this.givBdryCateList = this.agencyInfoService.givBdryCateList;
        this.givInfo.bdryCate = this.givBdryCateList[0].prop;
    };
    AddSubAgencyModalComponent.prototype.initCounties = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.agencyInfoService.getCounties()];
                    case 1:
                        _a.countyList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddSubAgencyModalComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initGivBdryTypes();
                        return [4 /*yield*/, this.initCounties()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AddSubAgencyModalComponent;
}());
export { AddSubAgencyModalComponent };
